import { render, staticRenderFns } from "./HistoryService.vue?vue&type=template&id=23a2d3b0&"
import script from "./HistoryService.vue?vue&type=script&lang=js&"
export * from "./HistoryService.vue?vue&type=script&lang=js&"
import style0 from "./HistoryService.vue?vue&type=style&index=0&id=23a2d3b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports